import React, { Component } from 'react'
import edit from "../../assets/images/edit.svg";
import delet from "../../assets/images/delet.svg";
import lock from "../../assets/images/lock.svg";
import share from "../../assets/images/share.svg";
import lockIcon from "../../assets/images/lock-icon.svg";
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment'
import LockIcon from '../../icons/LockIcon';
import LockCloseIcon from '../../icons/LockCloseIcon';
import service from '../../services';
import Cookies from 'universal-cookie';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

let sub;
const cookies = new Cookies();


const mapStateToProps = state => ({
    getLoginRole: state.getLoginRole,
    getLoginUser:state.getLoginUser
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class Partneradminlist extends Component {
    constructor(props) {
        super(props)
        this.state = {
            partners: [],
        }
        this.apiserve = new service();
    }

    componentDidMount() {
        if (this.props.partners) this.setState({ partners: this.props.partners });
        this.getEventData();
    }
    componentWillUnmount = () => {
        sub.unsubscribe();
    }
    getEventData = () => {
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case "loginUser":
                    if (!response.error) {
                        document.cookie = "particularNewUser" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                        cookies.remove("particularNewUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                        cookies.set('particularUser', response.data,{ domain:process.env.REACT_APP_COOKIE_DOMAIN, path: '/',secure:true });
                        let data = response.data;
                        const newRole = data.userData.additionalRoles.filter(role => role !== "generalUser")[0];
                        data.user.role = newRole;
                        this.props.LoginRole(data)
                        this.props.BackToAdminFlag(true)
                        localStorage.setItem('loginToken', response.data.token)  
                        localStorage.setItem('currentUserRole', data.user.role)   
                        this.apiserve.sendevent("getUser", { id: response.data.user._id });
                        
                    }else{
                        this.apiserve.error(response.data)
                    }
                    break;
                    case "getUser":
                        this.props.ProfileName(response.data)
                        break;
                    case "privateScreeningPartner|sendMail":
                        if(!response.error){
                            this.apiserve.success(response.data.message)
                        }else{
                            this.apiserve.error('Something went wrong, please try again leter')
                        }
                        break;
            }
        });
    };

    sendMail=(item)=>{
        if(item){
            this.apiserve.sendevent("privateScreeningPartner|sendMail", {email:item.email});
        }
    }
    loginUser = (userId) => {
        let data = {
            id:userId
        }
        this.props.LoginUser(this.props.getLoginRole);
        this.apiserve.sendevent("loginUser", data);
    }

    render() {
        return (
            <table className='film_list_table striped_table'>
                <thead>
                    <tr>
                        <th className="email_d" style={{ width: "240px" }}> Partner Name </th>
                        <th className="user_firstName_d" style={{ width: "170px" }}>First Name</th>
                        <th className="user_lastName_d" style={{ width: "170px" }}>Last Name</th>
                        <th className="user_company_d" style={{ width: "370px" }}>Email</th>

                        <th className="user_added_on" style={{ width: "140px" }}>last Logged On</th>
                        <th className="user_added_on" style={{ width: "140px" }}>Added On</th>
                        <th className="icon_d" style={{ width: "195px" }}> </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.state.partners.map(item => {
                            return (
                                <tr>
                                    <td className="email_d user_email_d" style={{ width: "230px" }}>

                                        <span className="user_status">
                                            {
                                                item.verified ? <svg className='active' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5H0ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.711V10.71Z" fill="black" />
                                                </svg>
                                                    :
                                                    <svg className='active' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.41319 0.104126C9.46181 0.104126 11.2095 0.827506 12.6562 2.27427C14.103 3.72102 14.8264 5.46292 14.8264 7.49996C14.8264 9.537 14.103 11.2789 12.6562 12.7257C11.2095 14.1724 9.46181 14.8958 7.41319 14.8958C5.36458 14.8958 3.6169 14.1724 2.17014 12.7257C0.72338 11.2789 0 9.537 0 7.49996C0 5.46292 0.72338 3.72102 2.17014 2.27427C3.6169 0.827506 5.36458 0.104126 7.41319 0.104126ZM8.15972 11.2152V9.72218H6.66667V11.2152H8.15972ZM8.15972 8.22913V3.78468H6.66667V8.22913H8.15972Z" fill="#FF8311" />
                                                    </svg>
                                            }
                                        </span>
                                        {item.partnerName}
                                    </td>
                                    <td className="firstName_d" style={{ width: "170px" }}>{item.fname}</td>
                                    <td className="lastName_d" style={{ width: "170px" }}>{item.lname}</td>
                                    <td className="depart_d" style={{ width: "350px" }}>{item.email}</td>
                                    <td className="regOn_d" style={{ width: "140px" }}>{item.lastLogin ? moment(item.lastLogin).format('MM/DD/YYYY') : ''}</td>
                                    <td className="regOn_d" style={{ width: "140px" }}>{moment(item.createdAt).format('MM/DD/YYYY')}</td>
                                    <td className="icon_d pr_0" style={{ width: "195px" }}>
                                        <Link onClick={() => this.props.onEditPartner(item)}>
                                            <img src={edit} /><div>edit</div>
                                        </Link>

                                        <Link className="lock_icon" onClick={() => this.props.blockPartner(item)}>
                                            {!item.isBlocked ? <LockIcon /> : <LockCloseIcon />}
                                            
                                            <div>{!item.isBlocked ? 'block' : 'unblock'}</div>
                                        </Link>


                                        <Link onClick={()=>this.props.deletePartner(item)}>
                                            <img src={delet} /><div>delete</div>
                                        </Link>
                                        <Link onClick={()=>this.loginUser(item._id)}>
                                            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E" />
                                                <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E" />
                                            </svg>
                                        </Link>
                                        <label className="check_admin ml_15" onClick={()=>this.sendMail(item)}>
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                            </svg>
                                        </label>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Partneradminlist)
